var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7874_243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5C13.6944 0.500001 17.5 4.30558 17.5 9C17.5 13.6944 13.6944 17.5 9 17.5C4.30558 17.5 0.500001 13.6944 0.5 9C0.5 4.30558 4.30558 0.5 9 0.5Z",
    fill: "#F4FBF6",
    stroke: "#7CD192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91257 12.3114C7.72575 12.3114 7.54726 12.2368 7.4155 12.103L4.84308 9.4887C4.57329 9.21402 4.57677 8.77344 4.85145 8.50295C5.12612 8.23386 5.56741 8.23664 5.83719 8.51132L7.89236 10.5999L12.1442 5.91728C12.4042 5.63216 12.8448 5.61195 13.1285 5.86989C13.4136 6.12853 13.4346 6.56911 13.1759 6.85493L8.42846 12.0834C8.2995 12.2256 8.11824 12.3079 7.92653 12.3121C7.92164 12.3114 7.91746 12.3114 7.91257 12.3114Z",
    fill: "#7CD192"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7874_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPros);
export default __webpack_public_path__ + "static/media/Pros.c3a179012794e9b1e6a713147815ec00.svg";
export { ForwardRef as ReactComponent };